'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _wendysKennyLoggins = require('wendys-kenny-loggins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AjaxAppender = function (_BaseAppender) {
    _inherits(AjaxAppender, _BaseAppender);

    function AjaxAppender(config) {
        _classCallCheck(this, AjaxAppender);

        var _this = _possibleConstructorReturn(this, (AjaxAppender.__proto__ || Object.getPrototypeOf(AjaxAppender)).call(this, config));

        _this.client = _axios2.default.create({
            url: _this.url,
            timeout: _this.timeout,
            headers: _this.headers
        });
        return _this;
    }

    _createClass(AjaxAppender, [{
        key: 'append',


        /**
         * sends the logs to the server
         * @param events events to be logged
         */
        value: function append(events) {
            var preparedEvents = this.prepareEvent(events);
            this.send(this.url, preparedEvents).catch(function (err) {
                return console.log(err);
            });
        }
    }, {
        key: 'prepareEvent',
        value: function prepareEvent(event) {
            return JSON.stringify(event);
        }

        /**
         * send the request.
         */

    }, {
        key: 'send',
        value: function send(endPoint, request) {
            if (this.client) {
                return this.client.post(endPoint, request);
            }

            throw new Error('No valid client configured ');
        }
    }], [{
        key: 'createAjaxAppender',
        value: function createAjaxAppender(config) {
            var defaults = {
                url: '/api/log',
                timeout: 1000,
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            try {
                return new AjaxAppender(_extends({}, defaults, config));
            } catch (err) {
                console.log(err);
            }
        }
    }]);

    return AjaxAppender;
}(_wendysKennyLoggins.BaseAppender);

exports.default = AjaxAppender;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-kenny-loggins-ajax-appender/lib/AjaxAppender.js
// module id = 869
// module chunks = 0